import * as React from 'react';

import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { MIAPACons } from '../../Utils/MipaConstant';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import  './planner.scss';

import { PersonaInitialsColor, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { Facepile, IFacepileProps, OverflowButtonType } from 'office-ui-fabric-react/lib/Facepile';

import { DirectionalHint} from 'office-ui-fabric-react/lib/ContextualMenu';
import { GraphRequest } from '../../Utils/GraphRequest';
import { Helper } from '../../Utils/Helper';

//https://github.com/OfficeDev/office-ui-fabric-react/blob/master/packages/office-ui-fabric-react/src/components/pickers/PeoplePicker/examples/PeoplePicker.Types.Example.tsx

export interface IProps {
  data?: CPlannerTask;
  Users;
  facepileProps;
  facepilePropsAssignedby;
  facepilePropsCreatedBy;
  Loadpic;
  Header;
  Phrases;
  ReloadPlannerTasks;
  Progress;
  groupMembers?;
  AssignedUsermethod?;
}
export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;

  groupMembers?: any[];
}
/*const baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';

const facepilePersonas: IFacepilePersona[] = [];*/

export default class TaskAssignment extends React.Component<IProps, IContextualMenuState>{

  private _menuButtonElement: HTMLElement | null;
  private isWorking = false;
  constructor(props: IProps) {
    super(props);
    this.state = {
      isCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      groupMembers: null
    };
  }
  //UserEmail.split("@")[1]
  public render() {

    let rowcss = "ms-Grid-row miparow";
    const { isCalloutVisible, beakWidth, groupMembers } = this.state;
    let assignedUsers = null;
    let unAssignedUser = null;
    if (isCalloutVisible) {
      assignedUsers = this.prepareAssignedUser(rowcss);
      unAssignedUser = this.prepareUnAssignedUsers(rowcss, groupMembers);
    }
    return (
      <React.Fragment>
        
        <i  title={this.props.Phrases.assignto} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked} className="addpeople ms-Icon ms-Icon--AddFriend x-hidden-focus"></i>
        {isCalloutVisible ? (
          <Callout

            className="ms-Callout-callout"
            onDismiss={this._onCalloutDismiss}
            target={this._menuButtonElement}
            directionalHint={DirectionalHint.topAutoEdge}
            coverTarget={false}
            isBeakVisible={true}
            gapSpace={0}
            beakWidth={beakWidth}
          >
            <div className='detailcallout'>

              <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                <div className="ms-Callout-content ms-Grid">
                  <div className="assignedLabel">
                    <span>{this.props.Phrases.assigned}</span>
                  </div>
                  <div>
                    {assignedUsers}
                  </div>
                  <div className="assignedLabel">
                    <span>{this.props.Phrases.unassigned}</span>
                  </div>
                  <div>{unAssignedUser}</div>
                </div>
              </div>
            </div>
          </Callout>
        ) : null}
        
        <Facepile {...this.props.facepileProps} />

        {this.props.facepilePropsCreatedBy && this.props.facepilePropsCreatedBy.personas && this.props.facepilePropsCreatedBy.personas.length>0?
        (
          <div className='ms-Grid'>
            <div className='ms-Grid-row d-table w-100'>
                <div className='ms-Grid-col ms-sm12 ms-lg6 ms-md6'>
                    <div style={{marginTop:'15px'}} title='Assigned by'>
                        <i className='ms-Icon ms-Icon--UserFollowed addpeople'></i>
                        <Facepile {...this.props.facepilePropsAssignedby} />
                    </div>
                </div>
                <div className='ms-Grid-col ms-sm12 ms-lg6 ms-md6'>
                    <div style={{marginTop:'15px',textAlign:'right'}} title='Created by'>
                    <i className='ms-Icon ms-Icon--AccountManagement addpeople'></i>
                    <Facepile {...this.props.facepilePropsCreatedBy} />
                  </div>
                </div>
            </div>
          </div>
        ):null

        }
        
        
      </React.Fragment>
    );
  }
  private _onCalloutDismiss = (): void => {
    this.isWorking = false;
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {
    if (this.state.groupMembers == null && this.props.groupMembers==null) {
      let groupmemebrapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupMembers.replace('{0}', this.props.data.groupId);
      GraphRequest.GET(groupmemebrapi, this.props.Header, (detail) => {
        //this.props.groupMembers=detail.data.value;
        this.setState({
          groupMembers: detail.data.value,
          isCalloutVisible: true
        });
      }, (error) => {
      }, ()=>{//TODO:Implement local progress
      });
      //}, this.props.Progress);
    }
    else if(this.props.groupMembers){
      this.setState({
        groupMembers: this.props.groupMembers,
        isCalloutVisible: !this.state.isCalloutVisible
      });
      return;
    }
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }
  private prepareAssignedUser = (rowcss) => {
    let users = [];
    for (var assignedTo in this.props.data.assignments) {
      if(this.props.data.assignments[assignedTo]!=null) {
        let user = this.props.Users.filter(u => u.id == assignedTo);
        if (user && user.length > 0) {
          user = user[0];
          users.push(this.getPlannerUserItem(user, true, rowcss));
        }
      }      
    }

    return users;
  }

  private prepareUnAssignedUsers = (rowcss, groupmembers) => {
    if (groupmembers) {
      let users = [];
      for (var i = 0; i < groupmembers.length; i++) {
        var assignedTo = groupmembers[i];
        if (this.props.data.assignments && this.props.data.assignments[assignedTo.id]) {
          continue;
        }
        let user = this.props.Users.filter(u => u.id == assignedTo.id);

        if (user && user.length > 0) {
          user = user[0];

          users.push(this.getPlannerUserItem(user, false, rowcss));
        }

      }
      return users;
    }
    else {
      return null;
    }

  }
  private getPlannerUserItem = (user, remove, rowcss) => {    
    let facepileProps: IFacepileProps = {
      personas: [],
      maxDisplayablePersonas: 5,
      overflowButtonType: OverflowButtonType.none,
      overflowButtonProps: {
        ariaLabel: 'More users',
        onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
      },
      ariaDescription: 'To move through the items use left and right arrow keys.'
    };


    let AssingeeInitial = user.givenName != null ? user.givenName.trim().substr(0, 1).toUpperCase() + user.surname.trim().substr(0, 1).toUpperCase() : user.displayName.trim().substr(0, 2).toUpperCase();
    let persion = {
      //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
      imageUrl:Helper.GetDefaultImage(),
      imageInitials: AssingeeInitial,
      personaName: user.displayName,
      initialsColor: PersonaInitialsColor.magenta
    };

    if (user.imagepath == null || user.imagepath == '') {
      //this.props.Loadpic(user.id);
    }
    else {
      persion.imageUrl = user.imagepath;
    }
    facepileProps.personas.push(persion);
facepileProps.personaSize=PersonaSize.size24;
    if (remove) {
      return (<div key={"Assigned_" + user.id} className={rowcss}>
        <div className="ms-Grid-col ms-sm12 taskassinged">
          <div style={{ float: 'left' }}>
            <Facepile {...facepileProps} />
          </div>
          <i title={this.props.Phrases.remove} onClick={() => { this.assignuserToTask(user.id, false); }} className="ms-Icon ms-Icon--ChromeClose x-hidden-focus" ></i>
        </div>

      </div>);
    }
    else {
      return (<div key={"unassinged_" + user.id} className={rowcss}>
        <div style={{cursor:'pointer'}} className="ms-Grid-col ms-sm12 taskassinged" onClick={() => { this.assignuserToTask(user.id, true); }}>
          <Facepile {...facepileProps} />
        </div>
      </div>);
    }
  }
  private assignuserToTask = (assignto, adduser) => {
    if(this.props.AssignedUsermethod){
      let item = {
        'assignments': {
        }
      };
      if(this.props.data.assignments){
        item.assignments=this.props.data.assignments;
      }
      if (adduser) {
        item.assignments[assignto] = {
          '@odata.type': "microsoft.graph.plannerAssignment",
          orderHint: " !"
        };
      }
      else {
        item.assignments[assignto] = null;
      }     
      return this.props.AssignedUsermethod(item,this.props.data.col);
      
    }
    if (this.isWorking == false) {
      this.isWorking = true;
      let taskbrapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlannerTaks + "/" + this.props.data.id;

      let header = { ...this.props.Header };
      let etag = this.props.data["@odata.etag"];
      header["If-Match"] = etag;
      header["Prefer"] = "return=representation";
      let item = {
        'assignments': {
        }
      };
      if (adduser) {
        item.assignments[assignto] = {
          '@odata.type': "microsoft.graph.plannerAssignment",
          orderHint: " !"
        };
      }
      else {
        item.assignments[assignto] = null;
      }
      GraphRequest.Patch(taskbrapi, header, item, (detail) => {
        this.isWorking = false;
        this.props.ReloadPlannerTasks(this.props.data.col);
      }, (error) => {

      }, ()=>{
        //TODO:Local progress
      });
    }

  }
}
